<template>
  <Selector 
    :options="optionList" 
    @dataChange="change" 
    :disabled="disabled" 
  ></Selector>
  <!-- :style="style" -->
</template>

<script>
import Selector from './Selector.vue'

export default {
  name: 'selector',
  components: { Selector },
  props: {
    customStyle: {
      type : Object , 
      default : null , 
    }, 
    placeholder: String,
    options: {
      type: String,
      default: 'process'
    },
    selected: {
      type: Number,
      default(){
        return 0
      }
    },
    disabled: { type: Boolean, default: false}
  },
  data() {
    // console.log( this.style ) ; 
    return {
      processOptions: [
        {value: '', label:'전체분야', select: true},
        // {value: 4, label:'에너지환경', select: true},
        {value: '4', label:'에너지환경'},
        {value: '3', label:'구조안전'},
        {value: '1', label:'스마트IT'},
      ],
      protocolOptions : [
        {value:'FULL', label: 'Full', select: true},
        {value:'UNIT', label: 'Unit', },
      ],
      optionList: null
    }
  },
  watch: {
  },
  mounted() {
    if(this.options === 'protocol') {
      this.optionList = this.processOptions
      // this.optionList = this.protocolOptions
    } else {
      this.optionList = this.processOptions
    }
    // console.log( "this.optionList", this.optionList )
    // this.$emit('mounted', this.optionList)
    this.change( this.optionList[0] )
  },
  methods : {
    change(value) {
      this.$emit('change', value);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


